import { ParkingFilters } from '../../../domain/parking';
import { LocalStorage } from '../../../utils';

const PARKING_FILTERS_KEY = 'parking-filters';

// === Parking Filters =================================

export const storeParkingFiltersInLocalStorage = (parkingFilters: ParkingFilters) =>
  LocalStorage.setItem(PARKING_FILTERS_KEY, parkingFilters);

export const getParkingFiltersFromLocalStorage = (): ParkingFilters => LocalStorage.getItem(PARKING_FILTERS_KEY);
